import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { FlexColumn, FlexColumnDiv, FlexRowDiv, FlexRowSpaceBetween } from "./common.styles";
import { HXMobilePageTitleText, HXMobilePageWithFixedHeaderAndFooterContent, mobilePageHPadding } from "./HXMobilePage.styles";
export const PreLoginParent = styled.form `
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding-top: ${(props) => (props.paddingTop !== undefined ? props.paddingTop : 16)}px;
    padding-bottom: ${(props) => (props.paddingBottom !== undefined ? props.paddingBottom : 16)}px;
    box-sizing: border-box;
    flex: 1 0 0;

    @media (min-width: 768px) {
        height: auto;
        min-height: 100%;
        align-items: center;
        padding-top: 0;
    }
`;
export const PreLoginContent = styled(HXMobilePageWithFixedHeaderAndFooterContent).attrs({ isHeaderAndFooterFixed: true }) `
    padding-top: ${(props) => (props.paddingTop !== undefined ? props.paddingTop : 200)}px;
    align-items: flex-start;
    gap: 24px;

    @media (min-width: 768px) {
        flex: 0 0 auto;
        overflow: visible;
        align-self: center;
        max-width: 448px;
        width: 100%;
    }
`;
export const PreLoginHeader = styled(FlexRowSpaceBetween) `
    align-items: center;
    padding: 0 ${mobilePageHPadding}px;

    @media (min-width: 768px) {
        padding: 0;
    }
`;
export const PreLoginLogos = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;
`;
export const PreLoginOrgLogoImage = styled.img `
    object-fit: contain;
    height: 20px;

    .fallback > & {
        display: none;
    }
`;
export const PreLoginFallbackName = styled.div `
    display: none;

    font-size: ${fontSizes.MICRO};
    width: 60px;

    .fallback > & {
        display: block;
    }
`;
export const PreLoginCompanyLogo = styled.img `
    height: 20px;
`;
export const PreLoginTitleAndIcon = styled(FlexRowDiv) `
    gap: 4px;
    align-items: center;
    padding: 0 ${mobilePageHPadding}px;

    @media (min-width: 768px) {
        padding: 0;
        margin-bottom: 16px;
    }
`;
export const PreLoginTitle = styled(HXMobilePageTitleText) ``;
export const PreLoginFooter = styled(FlexColumnDiv) `
    gap: 8px;
    padding: 16px ${mobilePageHPadding}px 0px ${mobilePageHPadding}px;

    @media (min-width: 768px) {
        max-width: 448px;
        width: 100%;
        margin-top: 24px;
        padding: 16px 0 0;
    }
`;
export const PreLoginCustomContentContainer = styled(FlexColumn) `
    padding: 0 ${mobilePageHPadding}px;

    @media (min-width: 768px) {
        padding: 0;
    }
`;
